package net.zagart.ai.core.client

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AiChatResponse(
    val id: String? = null,
    val choices: List<AiChoice> = emptyList(),
    val usage: AiUsage? = null
)

@Serializable
data class AiChoice(
    val index: Int = 0,
    val message: AiChatMessage? = null,
    val delta: AiChatMessage? = null,
    @SerialName("finish_reason")
    val finishReason: String? = null
)

@Serializable
data class AiUsage(
    @SerialName("prompt_tokens")
    val promptTokens: Int? = null,
    @SerialName("completion_tokens")
    val completionTokens: Int? = null,
    @SerialName("total_tokens")
    val totalTokens: Int? = null
)
